/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_TitleInputs */

const cs_sms_title = /** @type {(inputs: Sms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS`)
};

const en_sms_title = /** @type {(inputs: Sms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS`)
};

/**
* | output |
* | --- |
* | "SMS" |
*
* @param {Sms_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_title = /** @type {((inputs?: Sms_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_title(inputs)
	return cs_sms_title(inputs)
});